import type { EmailsThemeDto } from "@babackapp/private-api-client/types";
import { getContrastText, isDefaultColor } from "@babackapp/ui/lib/colors";

const COLOR_TEXT_PAIRS = [
  { colorKey: "backgroundColor", textKey: "backgroundTextColor" },
  { colorKey: "cardColor", textKey: "cardTextColor" },
  { colorKey: "primaryColor", textKey: "primaryTextColor" },
  { colorKey: "secondaryColor", textKey: "secondaryTextColor" },
] as const;

/**
 * Theme to save: the existing theme overwritten by the new values. When a
 * color changes, its text color follows the contrast, unless the merchant set
 * a custom one (anything but black or white).
 */
export function mergeEmailsTheme(
  newTheme: Partial<EmailsThemeDto>,
  existingTheme?: EmailsThemeDto | null,
): Partial<EmailsThemeDto> {
  const themeToSave: Partial<EmailsThemeDto> = {
    ...(existingTheme || {}),
    ...newTheme,
  };

  COLOR_TEXT_PAIRS.forEach(({ colorKey, textKey }) => {
    if (
      newTheme[colorKey] &&
      newTheme[colorKey] !== existingTheme?.[colorKey]
    ) {
      const existingTextColor = existingTheme?.[textKey] || newTheme[textKey];

      if (isDefaultColor(existingTextColor)) {
        themeToSave[textKey] = getContrastText(newTheme[colorKey] as string);
      }
    }
  });

  return themeToSave;
}
